import script from "./Results.vue?vue&type=script&setup=true&lang=js"
export * from "./Results.vue?vue&type=script&setup=true&lang=js"

import "./Results.vue?vue&type=style&index=0&id=5bf4c650&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5bf4c650"]])

export default __exports__